import { useSnapshot } from "valtio"
import { CheckoutStore, checkoutStore } from "./checkout-store"

export function useCheckout() {
  return useSnapshot(checkoutStore) as CheckoutStore
}
